export default __webpack_public_path__ + "static/media/Bongo.6afc066c.mp3";